import { memo } from 'react';
import ProductCard from '@/components/reusable/productCard/ProductCard';
import Box from '@/components/UI/box/Box';
import styles from './Cards.module.scss';
import { ProductListRecord } from '@/components/reusable/productCard/types';
interface CardsProps {
  isShowMap: boolean;
  perPage: number;
  data: ProductListRecord[] | null;
  page: number;
  searchId?: string;
}
const Cards = ({
  isShowMap,
  perPage,
  data,
  page = 1,
  searchId
}: CardsProps) => {
  return <Box className={styles.container} component={'ul'} data-sentry-element="Box" data-sentry-component="Cards" data-sentry-source-file="Cards.tsx">
      {data?.map((item: ProductListRecord, index) => item?.id && <Box key={item.id} component={'li'} className={isShowMap ? styles.product_card_container_with_map : styles.product_card_container}>
              <ProductCard searchId={searchId} data={item} isShowMap={isShowMap} index={index + (page - 1) * perPage} isFirstCard={index === 0} />
            </Box>)}
    </Box>;
};
export default memo(Cards);